/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const reportOverviewThesisDtoSchema = z.object({
  industry: z.optional(z.string()),
  businessModel: z.optional(z.string()),
  companyStage: z.optional(z.string()),
  productStage: z.optional(z.string()),
});
